import { render } from "./BrokerTxnsFileModalPopup.vue?vue&type=template&id=65c170c3&scoped=true"
import script from "./BrokerTxnsFileModalPopup.vue?vue&type=script&lang=js"
export * from "./BrokerTxnsFileModalPopup.vue?vue&type=script&lang=js"

import "./BrokerTxnsFileModalPopup.vue?vue&type=style&index=0&id=65c170c3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c170c3"]])

export default __exports__